import { Controller } from "@hotwired/stimulus";

interface ToggleSorterEvent extends Event {
  params?: {
    dir?: "asc" | "desc";
  };
}

export default class extends Controller<HTMLElement> {
  static readonly targets = ["sortValue"];

  declare readonly hasSortValueTarget: boolean;
  declare readonly sortValueTarget: HTMLInputElement;
  declare readonly sortValueTargets: HTMLInputElement[];

  static readonly values = {
    key: String,
  };

  declare readonly hasKeyValue: boolean;
  declare readonly keyValue: string;

  toggle(event: ToggleSorterEvent) {
    const nextDir = event.params?.dir;

    if (this.hasSortValueTarget && this.hasKeyValue) {
      if (nextDir) {
        this.sortValueTarget.value = `${this.keyValue} ${nextDir}`;
        this.sortValueTarget.disabled = false;
      } else {
        this.sortValueTarget.value = "";
        this.sortValueTarget.disabled = true;
      }

      const closestForm = this.sortValueTarget.closest("form");
      closestForm?.requestSubmit();
    }
  }
}
